import {
  Home,
  Shield,
  Wallet,
  BookOpen,
  Trophy,
  Users,
  Building2,
  BarChart3,
  Compass,
  Bell,
  FlaskConical,
  Award,
  Swords,
  ClipboardList,
  CreditCard,
  Store,
  HelpCircle,
  Timer,
  Calendar,
  FileText,
  MessageSquare,
  Baby,
  LayoutGrid,
  Users2,
  BarChart2,
  Camera,
  FileBarChart,
  Link2,
  PoundSterling,
  AlertTriangle,
  Settings,
  Globe,
  Scale,
  ShieldAlert,
  Clock,
  GraduationCap,
  Hash,
  type LucideIcon,
} from 'lucide-react'

export interface NavItem {
  label: string
  path: string
  icon: LucideIcon
  section?:
    | 'home'
    | 'my-shooting'
    | 'my-armoury'
    | 'competitions'
    | 'social'
    | 'club-mgmt'
    | 'platform-admin'
}

export const navItems: NavItem[] = [
  // Home (standalone, no heading)
  { label: 'Home', path: '/', icon: Home, section: 'home' },

  // My Shooting
  { label: 'Shoot Log', path: '/shoot-log', icon: BookOpen, section: 'my-shooting' },
  { label: 'Stats', path: '/stats', icon: BarChart3, section: 'my-shooting' },
  { label: 'Classifications', path: '/classifications', icon: Award, section: 'my-shooting' },
  { label: 'Challenges', path: '/challenges', icon: Swords, section: 'my-shooting' },
  { label: 'Chronograph', path: '/chronograph', icon: Timer, section: 'my-shooting' },
  { label: 'Training', path: '/training', icon: GraduationCap, section: 'my-shooting' },
  { label: 'Cherished Numbers', path: '/cherished-numbers', icon: Hash, section: 'my-shooting' },

  // My Armoury
  { label: 'Armoury', path: '/armoury', icon: Shield, section: 'my-armoury' },
  { label: 'Handloads', path: '/handloads', icon: FlaskConical, section: 'my-armoury' },
  { label: 'Wallet', path: '/wallet', icon: Wallet, section: 'my-armoury' },

  // Competitions
  { label: 'Discover', path: '/discover', icon: Compass, section: 'competitions' },
  { label: 'Competitions', path: '/competitions', icon: Trophy, section: 'competitions' },
  { label: 'Results', path: '/results', icon: ClipboardList, section: 'competitions' },
  { label: 'Score Challenges', path: '/score-challenges', icon: Scale, section: 'competitions' },
  { label: 'Calendar', path: '/calendar', icon: Calendar, section: 'competitions' },
  { label: 'Squadding', path: '/squadding', icon: LayoutGrid, section: 'competitions' },
  { label: 'RO Dashboard', path: '/ro-dashboard', icon: Shield, section: 'competitions' },
  { label: 'Briefings', path: '/briefings', icon: FileText, section: 'competitions' },
  { label: 'Runbook', path: '/runbook', icon: ClipboardList, section: 'competitions' },
  { label: 'DQ Tracking', path: '/dq-tracking', icon: ShieldAlert, section: 'competitions' },
  { label: 'Finances', path: '/competition-finance', icon: PoundSterling, section: 'competitions' },

  // Social & Community
  { label: 'Teams', path: '/teams', icon: Users, section: 'social' },
  { label: 'Clubs', path: '/clubs', icon: Building2, section: 'social' },
  { label: 'Messages', path: '/messages', icon: MessageSquare, section: 'social' },
  { label: 'Photos', path: '/photos', icon: Camera, section: 'social' },
  { label: 'Polls', path: '/polls', icon: BarChart2, section: 'social' },
  { label: 'Marketplace', path: '/marketplace', icon: Store, section: 'social' },
  { label: 'Cadets', path: '/cadets', icon: Baby, section: 'social' },
  { label: 'Family', path: '/family', icon: Users2, section: 'social' },

  // Club Management
  { label: 'Meetings', path: '/meetings', icon: Users, section: 'club-mgmt' },
  { label: 'Documents', path: '/documents', icon: FileText, section: 'club-mgmt' },
  { label: 'Club Portal', path: '/club-portal', icon: Globe, section: 'club-mgmt' },
  { label: 'Waiting List', path: '/waiting-list', icon: Clock, section: 'club-mgmt' },
  { label: 'Payments', path: '/payments', icon: CreditCard, section: 'club-mgmt' },
  { label: 'Credentials', path: '/credential-chains', icon: Link2, section: 'club-mgmt' },
  { label: 'Fault Reports', path: '/fault-reports', icon: AlertTriangle, section: 'club-mgmt' },
  { label: 'Training Admin', path: '/training-admin', icon: GraduationCap, section: 'club-mgmt' },

  // Platform Admin
  { label: 'Reports', path: '/reports', icon: FileBarChart, section: 'platform-admin' },
  { label: 'Exports', path: '/exports', icon: Shield, section: 'platform-admin' },
  { label: 'Custom Fields', path: '/custom-fields', icon: Settings, section: 'platform-admin' },
  { label: 'Support', path: '/support', icon: HelpCircle, section: 'platform-admin' },
  { label: 'Notifications', path: '/notifications', icon: Bell, section: 'platform-admin' },
]
